/**
 * The syncs with Profer (contract v10.46, ADR 0041 of the back): only this screen needs
 * them, so they live here and not in `shared/clients`. The lookup of one client, which the
 * quote editor needs too, is in `shared/clients/api.ts`.
 */
import { api, type Page } from '@/shared/api/client';

import type { ClientSync, ClientSyncDetail } from './types';

export const proferSyncKeys = {
  all: ['client-syncs'] as const,
  list: ['client-syncs', 'list'] as const,
  detail: (id: string) => ['client-syncs', 'detail', id] as const,
};

export const proferSyncApi = {
  /** The last syncs, newest first: the nightly ones and the button's. Managers only. */
  list: (limit = 10): Promise<Page<ClientSync>> =>
    api.get<Page<ClientSync>>('/api/clients/syncs', { limit }),

  /** What one did, client by client. The lists are cut at 200; the counts are not. */
  detail: (id: string): Promise<ClientSyncDetail> =>
    api.get<ClientSyncDetail>(`/api/clients/syncs/${id}`),

  /** «Actualizar desde Profer». 202 with the one already running, if there is one. */
  request: (): Promise<ClientSync> => api.post<ClientSync>('/api/clients/sync'),
};
